module.exports = __webpack_public_path__ + "bde70af2f5e26038c55b6062dbfd9a7e.MP3";